import SpaceDashboardIcon from '@mui/icons-material/SpaceDashboard';
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
import AddCardIcon from '@mui/icons-material/AddCard';
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile';
import InfoIcon from '@mui/icons-material/Info';
import BarChartIcon from '@mui/icons-material/BarChart';
import CalculateIcon from '@mui/icons-material/Calculate';
import QueryStatsIcon from '@mui/icons-material/QueryStats';
import RuleIcon from '@mui/icons-material/Rule';
import DescriptionIcon from '@mui/icons-material/Description';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import StorageIcon from '@mui/icons-material/Storage';
import ShowChartIcon from '@mui/icons-material/ShowChart';
import AssessmentIcon from '@mui/icons-material/Assessment';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import PhoneAndroidIcon from '@mui/icons-material/PhoneAndroid';
import NotificationsIcon from '@mui/icons-material/Notifications';
import CampaignIcon from '@mui/icons-material/Campaign';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import HealthAndSafetyIcon from '@mui/icons-material/HealthAndSafety';
import TuneIcon from '@mui/icons-material/Tune';
import CurrencyExchangeIcon from '@mui/icons-material/CurrencyExchange';
import ShieldIcon from '@mui/icons-material/Shield';
import VerifiedUserIcon from '@mui/icons-material/VerifiedUser';
import BoltIcon from '@mui/icons-material/Bolt';
import QrCodeScannerIcon from '@mui/icons-material/QrCodeScanner';
import FactCheckIcon from '@mui/icons-material/FactCheck';
import TravelExploreIcon from '@mui/icons-material/TravelExplore';

// ____ Main ____
export const MainMenuList = [
  {
    title: "Dashboard",
    path: '/admin/dashboard',
    icon: <SpaceDashboardIcon style={{fontSize:"18px",color:'#ADADAD'}}/>,
    active: <SpaceDashboardIcon style={{fontSize:"18px",color:"black"}}/>,
  },
  {
    title: "Deposits",
    path: '/admin/fundsdeposit',
    icon: <AddCardIcon style={{fontSize:"18px",color:'#ADADAD'}}/>,
    active: <AddCardIcon style={{fontSize:"18px",color:"black"}}/>,
  },
  {
    title: "Withdrawal",
    path: '/admin/withdrawfunds',
    icon: <AccountBalanceWalletIcon style={{fontSize:"18px",color:'#ADADAD'}}/>,
    active: <AccountBalanceWalletIcon style={{fontSize:"18px",color:"black"}}/>,
  },
  {
    title: "Performance",
    path: '/admin/monthlygraph',
    icon: <TrendingUpIcon style={{fontSize:"18px",color:'#ADADAD'}}/>,
    active: <TrendingUpIcon style={{fontSize:"18px",color:"black"}}/>,
  },
  {
    title: "Yield Products",
    path: '/admin/yield-products',
    icon: <ShowChartIcon style={{fontSize:"18px",color:'#ADADAD'}}/>,
    active: <ShowChartIcon style={{fontSize:"18px",color:"black"}}/>,
  },
  {
    title: "Yield Monthly",
    path: '/admin/yield-monthly',
    icon: <AssessmentIcon style={{fontSize:"18px",color:'#ADADAD'}}/>,
    active: <AssessmentIcon style={{fontSize:"18px",color:"black"}}/>,
  },
  {
    title: "Yield Final",
    path: '/admin/yield-final',
    icon: <CheckCircleIcon style={{fontSize:"18px",color:'#ADADAD'}}/>,
    active: <CheckCircleIcon style={{fontSize:"18px",color:"black"}}/>,
  },
];

// ____ Compliance ____
export const ComplianceMenuList = [
  {
    title: "Customer Management",
    path: '/admin/customermanagement',
    icon: <PersonAddIcon style={{fontSize:"18px",color:'#ADADAD'}}/>,
    active: <PersonAddIcon style={{fontSize:"18px",color:"black"}}/>,
  },
  {
    title: "KYC Control Center",
    path: '/admin/kyc-control-center',
    icon: <VerifiedUserIcon style={{fontSize:"18px",color:'#ADADAD'}}/>,
    active: <VerifiedUserIcon style={{fontSize:"18px",color:"black"}}/>,
  },
  {
    title: "Wallet Management",
    path: '/admin/wallet-management',
    icon: <CurrencyExchangeIcon style={{fontSize:"18px",color:'#ADADAD'}}/>,
    active: <CurrencyExchangeIcon style={{fontSize:"18px",color:"black"}}/>,
  },
  {
    title: "Wallet Check",
    path: '/admin/wallet-check',
    icon: <QrCodeScannerIcon style={{fontSize:"18px",color:'#ADADAD'}}/>,
    active: <QrCodeScannerIcon style={{fontSize:"18px",color:"black"}}/>,
  },
  {
    title: "Wallet Reconciliation",
    path: '/admin/wallet-reconciliation',
    icon: <FactCheckIcon style={{fontSize:"18px",color:'#ADADAD'}}/>,
    active: <FactCheckIcon style={{fontSize:"18px",color:"black"}}/>,
  },
];

// ____ Analyses ____
export const AnalysesMenuList = [
  {
    title: "Fund Control Centre",
    path: '/admin/fund-control-center',
    icon: <CalculateIcon style={{fontSize:"18px",color:'#ADADAD'}}/>,
    active: <CalculateIcon style={{fontSize:"18px",color:"black"}}/>,
  },
  {
    title: "Fund Performance History",
    path: '/admin/fund-analytics',
    icon: <QueryStatsIcon style={{fontSize:"18px",color:'#ADADAD'}}/>,
    active: <QueryStatsIcon style={{fontSize:"18px",color:"black"}}/>,
  },
  {
    title: "Global Performance",
    path: '/admin/yearly-graph',
    icon: <BarChartIcon style={{fontSize:"18px",color:'#ADADAD'}}/>,
    active: <BarChartIcon style={{fontSize:"18px",color:"black"}}/>,
  },
];

const item = (title, path, Icon) => ({
  title,
  path,
  icon: <Icon style={{fontSize:"18px",color:'#ADADAD'}}/>,
  active: <Icon style={{fontSize:"18px",color:"black"}}/>,
});

// ____ Tools — things you use (not configuration) ____
export const ToolsMenuGroups = [
  {
    id: 'communications',
    title: 'Communications',
    items: [
      item("Notification Center", '/admin/notifications', NotificationsIcon),
      item("Client Communications", '/admin/client-communications', CampaignIcon),
      item("Scheduled Reminders", '/admin/reminders', CalendarTodayIcon),
    ],
  },
  {
    id: 'reports',
    title: 'Reports',
    items: [
      item("PDF Report Generator", '/admin/pdf-report-generator', PictureAsPdfIcon),
      item("Report Library", '/admin/report-library', AssessmentIcon),
    ],
  },
  {
    id: 'operations',
    title: 'Operations',
    items: [
      item("System Health", '/admin/system-health', HealthAndSafetyIcon),
      item("KATU Visits", '/admin/katu-visits', TravelExploreIcon),
      item("Auto-Pay Flow", '/admin/auto-pay-flow', BoltIcon),
      item("Advanced Tools", '/admin/database-analysis', StorageIcon),
    ],
  },
];

// ____ Settings — configuration and legal content ____
export const SettingsMenuGroups = [
  {
    id: 'configuration',
    title: 'Configuration',
    items: [
      item("Fund Rules", '/admin/fund-rules', RuleIcon),
      item("Report Settings", '/admin/pdf-report-settings', DescriptionIcon),
      item("App Version", '/admin/app-version-settings', PhoneAndroidIcon),
      item("Admin Settings", '/admin/admin-settings', TuneIcon),
      item("Security Architecture", '/admin/security-architecture', ShieldIcon),
    ],
  },
  {
    id: 'legal',
    title: 'Legal',
    items: [
      item("About Us", '/admin/aboutus', InfoIcon),
      item("Privacy Policy", '/admin/privacypolicy', InsertDriveFileIcon),
      item("Terms & Conditions", '/admin/termsandconditions', InsertDriveFileIcon),
    ],
  },
];

export const ToolsMenuList = ToolsMenuGroups.flatMap((group) => group.items);
export const SettingsMenuList = SettingsMenuGroups.flatMap((group) => group.items);
